import React, { Fragment } from "react";
import { PageHero } from "../components/Global/PageHero";
import { MemberForm } from "../components/Member/MemberForm";
import { BackToTop } from "../templates/BackToTop";

export const Join = () => (
  <Fragment>
    <PageHero
      eyebrow="Join Our Family"
      title="Become a"
      highlight="Member"
      subtitle="Fill in your details below to register and become part of our church family."
    />
    <MemberForm />
    <BackToTop />
  </Fragment>
);
